import { ServerFilteringTableExportHelper } from "src/uicomponents/components/extable/ServerFilteringTableExportHelper";
import { CurrentCredentials } from "./currentCredentials";
import { MainWindowViewModel } from "src/common/mainWindow/mainWindow-viewModel";
import { UserMainWindowViewModel } from "src/common/userMainWindow/userMainWindow-viewModel";
// import * as CryptoJS from 'crypto-js';
declare var serverAddressToSendRequest:string;

export class ServerConnection{
    
    public static callServerWithUsernameAndPassword(service: string, body: any,username:string,password:string,macAddresses:string[]=[],sessionId:string): Promise<any> {
        // let salt = Math.random().toString();
        // if(stringIsNullOrEmpty(sessionId)){
        //     sessionId = "";
        // }
        // let tokenContent = `${username.length.toString().padStart(3,'0')}${password.length.toString().padStart(3,'0')}${sessionId.length.toString().padStart(3,'0')}${username}${password}${sessionId}${salt}`;
        // let key = CryptoJS.enc.Utf8.parse('dd97057a37024b0b8ff82336b5df68e7');
        // let iv = CryptoJS.enc.Utf8.parse('8d93c017b85b492c');
        // let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(tokenContent), key,
        // {
        //     keySize: 32,
        //     iv: iv,
        //     mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        // });
        // let realEncrypted = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

        // (<any>body).AuthenticationInformation= { AccessToken:realEncrypted,MacAddresses:macAddresses };
        (<any>body).AuthenticationInformation= { Username: username, Password: password,MacAddresses:macAddresses,SessionId:sessionId };
        return new Promise<JSON>((resolvedFunction, rejectFunction) => {
            let request = new XMLHttpRequest();
            // request.open('POST','http://localhost:48010');
            request.open('POST',serverAddressToSendRequest);
            // request.open('POST','http://192.168.20.49:48010/api');
            // request.open('POST','https://erp.ashiangostaran.com/api');
            // request.open('POST','/api');
            
            let isExportRequest : boolean=false;
            let exportCounter : -1;
            try{
                let filteringInformationKey : any = Object.keys(body).filter(x=>body[x]!=null).filter(x=>Object.keys(body[x]).includes("NOTIMPORTANT_EXPORT_FILTERING_OBJECT_PLACEHOLDER")).at(0);
                let filteringInformation = body[filteringInformationKey];
                filteringInformation["NOTIMPORTANT_EXPORT_FILTERING_OBJECT_PLACEHOLDER"] = undefined;
                if(filteringInformation!=null && filteringInformation.RequestExportingInfo && filteringInformation.RequestExportingInfo.Counter){
                    isExportRequest = true;
                    exportCounter = filteringInformation.RequestExportingInfo.Counter;
                    filteringInformation.RequestExportingInfo.Counter = undefined;
                }
            }catch{}

            let requestBody = `${service}\r\n${JSON.stringify(body)}`;
            request.onload = function () {
                let isFailed = true;
                
                let exportResult = null;
                if (this.status == 200) {
                    let result = JSON.parse(request.response);
                    
                    if(result.HasCatastrophicError==false){
                        if(isExportRequest){
                            rejectFunction({status:200,internal:true,exportInfo : result.ExportingInfoResponse})
                            exportResult = result.ExportingInfoResponse;
                            isFailed = false;
                        }else{
                            resolvedFunction(result);
                        }
                    }else{
                        rejectFunction({ status: request.status, statusText: result.Faults[0] });
                    }
                } else {
                    rejectFunction({ status: request.status, statusText: request.statusText });
                }
                if(isExportRequest){
                    if(isFailed){
                        ServerFilteringTableExportHelper.ResultReceived(exportCounter,null,true)
                    }else{
                        ServerFilteringTableExportHelper.ResultReceived(exportCounter,exportResult,false)
                    }
    
                }
            }
            request.onerror = function () { rejectFunction({ status: request.status, statusText: request.statusText }); }
            request.send(requestBody);
        })
    }

    public static callServer(service: string, body: Object): Promise<any> {
        return this.callServerWithUsernameAndPassword(service,body,CurrentCredentials.username,CurrentCredentials.password,[],CurrentCredentials.sessionId);
    }

}